import { useContext } from 'react';
import { HomepageEditorContext } from '../HomepageEditorContext';

export const useIsMobile = () => {
  const { isMobile } = useContext(HomepageEditorContext);

  return isMobile;
};
